export const SvmAddressRegex = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
